import React from 'react'
import { FaArrowRight } from 'react-icons/fa6';
import { blogData } from '../../allData/Data';
import { Link } from 'react-router-dom';

const Blogbox = () => {

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        blogData.map((item) => {
            return (
                <div className="col-lg-4 col-md-6">
                    <div className="blogBox">
                        <img src={require('../../../assets/images/blog/blog-1.jpg')} alt='img' />
                        <figcaption>
                            <h6>{item?.date}</h6>
                            <h3>{item?.heading}</h3>
                            <p>{item?.content}</p>
                            <Link to="/blog-details" onClick={scrollToTop}>Read More <FaArrowRight /></Link>
                        </figcaption>
                    </div>
                </div>
            )
        })
    )
}

export default Blogbox;